import { render, staticRenderFns } from "./OrgHomeClosedCases.vue?vue&type=template&id=694fa56f&"
import script from "./OrgHomeClosedCases.vue?vue&type=script&lang=js&"
export * from "./OrgHomeClosedCases.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeClosedCases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports